import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <p className="text-sm text-warmGray mb-4">İLETİŞİM</p>
            <h1 className="text-5xl md:text-6xl font-display font-bold text-navy mb-6">
              Hakkımızdale İletişime Geçin
            </h1>
            <p className="text-lg text-warmGray leading-relaxed">
              Sorularınız için bize ulaşın, size en kısa sürede dönüş yapalım
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white rounded-3xl p-8">
              <h2 className="text-2xl font-display font-bold text-navy mb-6">İletişim Bilgileri</h2>

              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-mint rounded-full">
                    <i className="ri-phone-line text-xl text-navy"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-navy mb-1">Telefon</h3>
                    <a href="tel:+902165190313" className="text-warmGray hover:text-coral transition-colors">
                      0216 519 03 13
                    </a>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-mint rounded-full">
                    <i className="ri-mail-line text-xl text-navy"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-navy mb-1">E-posta</h3>
                    <a href="mailto:info@atolyemini.com" className="text-warmGray hover:text-coral transition-colors">
                      info@atolyemini.com
                    </a>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-mint rounded-full">
                    <i className="ri-map-pin-line text-xl text-navy"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-navy mb-1">Adres</h3>
                    <p className="text-warmGray leading-relaxed">
                      Finanskent Mah. Finans Cad.<br />
                      Sarphan Finanspark Blok B2 Ofis 387<br />
                      Ataşehir / İstanbul
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-mint rounded-full">
                    <i className="ri-time-line text-xl text-navy"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-navy mb-1">Çalışma Saatleri</h3>
                    <p className="text-warmGray">Pazartesi - Cuma: 09:00 - 18:00</p>
                    <p className="text-warmGray">Cumartesi: 10:00 - 16:00</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200">
                <h3 className="text-sm font-semibold text-navy mb-4">Sosyal Medya</h3>
                <div className="flex gap-4">
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-mint rounded-full text-navy hover:bg-coral hover:text-white transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-mint rounded-full text-navy hover:bg-coral hover:text-white transition-colors cursor-pointer">
                    <i className="ri-facebook-circle-line text-xl"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-mint rounded-full text-navy hover:bg-coral hover:text-white transition-colors cursor-pointer">
                    <i className="ri-linkedin-box-line text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8">
              <h2 className="text-2xl font-display font-bold text-navy mb-6">Mesaj Gönderin</h2>
              <p className="text-warmGray mb-6">
                Formu doldurarak bize ulaşabilirsiniz. En kısa sürede size geri dönüş yapacağız.
              </p>

              <div className="bg-mint/30 rounded-2xl p-6 text-center">
                <i className="ri-mail-send-line text-4xl text-navy mb-4"></i>
                <p className="text-navy font-medium mb-2">İletişim Formu</p>
                <p className="text-sm text-warmGray">
                  Lütfen bizimle iletişime geçmek için yukarıdaki iletişim bilgilerini kullanın.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;